(function () {
  'use strict';

  if (window.matchMedia('(min-width: 1024px)').matches) return;

  // Features truncation is now Liquid-driven (see main-product.liquid
  // dd-features render block) and works across all viewports. The previous
  // mobile-only JS implementation (.dd-features--hidden / --expanded /
  // .dd-features__toggle injected here) has been retired in favor of the
  // unified system using `.is--extra` items + a Liquid-rendered toggle row.

  function initDescriptionTruncation() {
    var desc = document.querySelector('.dd-short-description');
    if (!desc) return;

    var naturalHeight = desc.scrollHeight;
    var clampHeight = parseFloat(getComputedStyle(desc).maxHeight) || 0;
    if (clampHeight <= 0) clampHeight = 88;
    if (naturalHeight <= clampHeight + 10) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dd-description__toggle';
    btn.textContent = 'Read more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var isExpanded = desc.classList.toggle('dd-description--expanded');
      btn.textContent = isExpanded ? 'Read less' : 'Read more';
      btn.setAttribute('aria-expanded', String(isExpanded));
    });
    desc.after(btn);
  }

  function initTrustMarquee() {
    var badges = document.querySelector('.dd-trust-badges');
    if (!badges || badges.dataset.marqueeInit) return;
    badges.dataset.marqueeInit = 'true';

    var rows = Array.from(badges.querySelectorAll('.dd-trust-badges__row'));
    if (rows.length < 2) return;

    var track = document.createElement('div');
    track.className = 'dd-trust-badges__track';

    for (var i = 0; i < rows.length; i++) {
      track.appendChild(rows[i]);
      if (i < rows.length - 1) {
        track.appendChild(createSep());
      }
    }

    track.appendChild(createSep());

    for (var j = 0; j < rows.length; j++) {
      track.appendChild(rows[j].cloneNode(true));
      if (j < rows.length - 1) {
        track.appendChild(createSep());
      }
    }

    badges.appendChild(track);

    function createSep() {
      var dot = document.createElement('span');
      dot.className = 'dd-trust-badges__sep';
      dot.setAttribute('aria-hidden', 'true');
      return dot;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDescriptionTruncation();
      initTrustMarquee();
    });
  } else {
    initDescriptionTruncation();
    initTrustMarquee();
  }
})();
